module.exports = __webpack_public_path__ + "img/background23.c178eca8.jpg";